export default "__VITE_PUBLIC_ASSET__50bd5e32__"